/**
 * Engagement types for FirmNest Practice Management
 */

export type ServiceLine =
  | 'tax_1040'
  | 'tax_1040nr'
  | 'tax_1120'
  | 'tax_1120s'
  | 'tax_1065'
  | 'tax_5472'
  | 'payroll'
  | 'sales_tax'
  | 'qbo_setup'
  | 'consulting'

export type EngagementStatus =
  | 'draft'
  | 'active'
  | 'in_progress'
  | 'under_review'
  | 'approved'
  | 'completed'
  | 'cancelled'

export interface Engagement {
  id: string
  firm_id: string
  client_id: string
  service_line: ServiceLine
  tax_year?: number
  status: EngagementStatus
  config: Record<string, unknown>
  assigned_to?: string
  reviewer?: string
  due_date?: string
  completed_at?: string
  notes?: string
  created_at: string
  updated_at: string
  created_by?: string
  // Joined data
  client?: { name: string; client_type: string; client_number?: number }
}

export const SERVICE_LINE_LABELS: Record<ServiceLine, string> = {
  tax_1040: '1040 Individual',
  tax_1040nr: '1040-NR Non-Resident',
  tax_1120: '1120 C-Corp',
  tax_1120s: '1120-S S-Corp',
  tax_1065: '1065 Partnership',
  tax_5472: '5472 Foreign-Owned',
  payroll: 'Payroll',
  sales_tax: 'Sales Tax',
  qbo_setup: 'QBO Setup',
  consulting: 'Consulting'
}

export const STATUS_LABELS: Record<EngagementStatus, string> = {
  draft: 'Draft',
  active: 'Active',
  in_progress: 'In Progress',
  under_review: 'Under Review',
  approved: 'Approved',
  completed: 'Completed',
  cancelled: 'Cancelled'
}

export const STATUS_COLORS: Record<EngagementStatus, string> = {
  draft: 'gray',
  active: 'blue',
  in_progress: 'yellow',
  under_review: 'purple',
  approved: 'green',
  completed: 'green',
  cancelled: 'red'
}
